<section class="feature-settings">
  <header>
    <p class="eyebrow">Administration</p>
    <h2>Feature management</h2>
    <p>Manage default availability and more specific rules for each audience.</p>
  </header>

  <div class="message success" role="status" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading" *ngIf="isLoading">Loading feature settings...</div>

  <div class="feature-list" *ngIf="!isLoading">
    <article class="feature-card" *ngFor="let flag of flags; trackBy: trackByKey">
      <div class="feature-heading">
        <div class="feature-copy">
          <h3>{{ flag.displayName }}</h3>
          <code>{{ flag.key }}</code>
          <p>{{ flag.description }}</p>
          <small>
            Last modified {{ flag.modifiedDate ? (flag.modifiedDate | date:'medium') : 'not recorded' }}
            <ng-container *ngIf="flag.modifiedByUserID"> by user {{ flag.modifiedByUserID }}</ng-container>
          </small>
        </div>
        <label class="switch">
          <span class="default-label">Default state</span>
          <input type="checkbox"
                 [checked]="flag.isEnabled"
                 [disabled]="saving.has(flag.key)"
                 [attr.aria-label]="'Enable ' + flag.displayName + ' by default'"
                 (change)="requestDefaultChange(flag, $any($event.target).checked)">
          <span class="slider"></span>
          <span class="state">{{ saving.has(flag.key) ? 'Saving…' : (flag.isEnabled ? 'Enabled' : 'Disabled') }}</span>
        </label>
      </div>

      <p class="helper">Default state applies when no more specific audience rule matches.</p>
      <div class="override-heading">
        <div>
          <h4>Audience overrides</h4>
          <p>A type-specific operator rule takes precedence over a role-wide operator rule.</p>
        </div>
        <button type="button" class="secondary-action" (click)="addOverride(flag)" [disabled]="saving.has(flag.key)">Add rule</button>
      </div>

      <div class="override-table" *ngIf="drafts[flag.key]?.length">
        <div class="override-row header" aria-hidden="true">
          <span>Role</span><span>Operator type</span><span>State</span><span>Actions</span>
        </div>
        <div class="override-row" *ngFor="let draft of drafts[flag.key]">
          <label><span class="mobile-label">Role</span>
            <select [(ngModel)]="draft.role" (ngModelChange)="roleChanged(flag, draft)" [disabled]="saving.has(flag.key)">
              <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
            </select>
          </label>
          <label><span class="mobile-label">Operator type</span>
            <select [(ngModel)]="draft.operatorType" (ngModelChange)="inlineErrors[flag.key] = ''"
                    [disabled]="draft.role !== 'operator' || saving.has(flag.key)">
              <option value="">All operator types</option>
              <option *ngFor="let type of operatorTypes(flag, draft)" [value]="type">{{ type }}</option>
            </select>
          </label>
          <label><span class="mobile-label">State</span>
            <select [(ngModel)]="draft.isEnabled" [disabled]="saving.has(flag.key)">
              <option [ngValue]="true">Enabled</option>
              <option [ngValue]="false">Disabled</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="save-rule" (click)="saveOverride(flag, draft)" [disabled]="saving.has(flag.key)">Save</button>
            <button type="button" class="remove-rule" (click)="removeOverride(flag, draft)" [disabled]="saving.has(flag.key)">Remove</button>
          </div>
        </div>
      </div>
      <p class="empty-rules" *ngIf="!drafts[flag.key]?.length">No audience overrides. The default state applies to everyone.</p>
      <p class="inline-error" role="alert" *ngIf="inlineErrors[flag.key]">{{ inlineErrors[flag.key] }}</p>
    </article>
    <p class="empty" *ngIf="!flags.length">No feature settings are available.</p>
  </div>
</section>

<app-confirm-dialog
  *ngIf="pendingDisable"
  title="Disable feature globally?"
  [message]="'Disable ' + pendingDisable.displayName + ' by default? Audience overrides may still enable it for specific users.'"
  confirmLabel="Disable default"
  tone="danger"
  (confirmed)="confirmDisable()"
  (cancelled)="pendingDisable = null">
</app-confirm-dialog>
